var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSmallViewport)?_c('div',[_c('homeDesktop')],1):_c('div',[_c('homeMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }